import { useState, useEffect } from 'react';
import { appname, appnameonly, applogo ,slides} from "../variables";

export default function AuthLayout({ title, subtitle, children }) {
  const [currentSlide, setCurrentSlide] = useState(0);


  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <div className="vh-100 overflow-hidden bg-white">
      <div className="row g-0 h-100">
        
        {/* LEFT SIDE: 60% - BRANDING (Dark Gradient) */}
        <div className="col-lg-7 d-none d-lg-flex flex-column justify-content-center align-items-center text-white p-5 position-relative"
          style={{ background: 'linear-gradient(135deg, #4C1D95 0%, #0E7490 100%)' }}>
          
          <div className="position-absolute top-0 start-0 p-5" style={{ zIndex: 10 }}>
            {/* White Logo for dark background */}
            <img src={appnameonly} alt={appname} style={{ width: '160px', filter: 'brightness(0) invert(1)' }} />
          </div>

          <div className="text-center mb-4">
               <img src={applogo || appnameonly} alt={appname} style={{ width: '260px' }} />
            </div>


          <div className="text-center z-1 w-100 px-5 mt-5">
            <div key={currentSlide} style={{ animation: 'slideUpFade 0.8s ease-out' }}>
              <h1 className="fw-black mb-3 display-3" style={{ letterSpacing: '-3px', lineHeight: '1' }}>
                {slides[currentSlide].title} <br />
                <span style={{ color: slides[currentSlide].accent }}>Faster.</span>
              </h1>
              <p className="fs-5 opacity-75 mx-auto fw-medium mb-5" style={{ maxWidth: '480px' }}>{slides[currentSlide].desc}</p>
            </div>
            {/* ... Navigation Dots ... */}
            <div className="d-flex justify-content-center gap-2 mt-5">
              {slides.map((_, i) => (
                <div key={i} className={`rounded-pill transition-all ${currentSlide === i ? 'bg-white' : 'bg-white opacity-25'}`} 
                     style={{ height: '6px', width: currentSlide === i ? '40px' : '6px', cursor: 'pointer' }}
                     onClick={() => setCurrentSlide(i)}></div>
              ))}
            </div>
          </div>
        </div>

        {/* RIGHT SIDE: 40% - FORM SIDE (White Background) */}
        <div className="col-lg-5 d-flex align-items-center justify-content-center p-4 p-md-5 bg-white">
          <div className="w-100" style={{ maxWidth: '400px' }}>
            
            {/* MAIN LOGO: Removed the 'invert' filter so it's visible on white */}
         
            <div className="mb-5 text-center">
              <h2 className="fw-black text-dark mb-1 h1" style={{ letterSpacing: '-1px' }}>{title}</h2>
              <p className="text-muted fw-medium fs-6">{subtitle}</p>
            </div>

            <div className="auth-content-area">
              {children}
            </div>

            <div className="mt-5 pt-4 text-center">
               <p className="text-muted" style={{ fontSize: '11px', letterSpacing: '1px' }}>
                  <i className="fas fa-lock me-2"></i> ENTERPRISE-GRADE SECURITY
               </p>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slideUpFade { 0% { opacity: 0; transform: translateY(20px); } 100% { opacity: 1; transform: translateY(0); } }
        .fw-black { font-weight: 900 !important; }
      `}</style>
    </div>
  );
}